import { LOAN_PRODUCT_TYPE } from 'apps/di-ld/src/app/core/constant/base.enum';

export default {
  campaignId: 'smartmoney3',
  cifNo: '9779523',
  effectiveDate: '2021-07-21T21:05:02+07:00',
  expirationDate: '2021-07-28T21:05:02+07:00',
  maxCreditLimit: 1000000,
  maxInterestRate: 20,
  minCreditLimit: 5000,
  minInterestRate: 1,
  personalizedMessage: null,
  personalizedTitle: null,
  productType: LOAN_PRODUCT_TYPE.SMARTMONEY,
  productNameEn: 'Krungthai Smart Money Loan',
  productNameTh: 'สินเชื่อกรุงไทย Smart Money',
};
